module.exports = __webpack_public_path__ + "img/etapes.c663d886.png";